import React, { useState, useEffect } from 'react'
import styles from './SliderMinMax.module.scss'
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'

export function Handle({
  handle: { id, value, percent },
  getHandleProps
}) {
  return (
    <div
      style={{
        left: `${percent - 3}%`,
        position: 'absolute',
        marginTop: 25,
        zIndex: 2,
        width: 10,
        height: 10,
        border: 0,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '16px',
        backgroundColor: '#FCAF17',
        color: '#333',
      }}
      {...getHandleProps(id)}
    >
      <div style={{ fontSize: 11, marginTop: -20, marginLeft: -10 }}>
        {value}
      </div>
    </div>
  )
}

function Track({ source, target, getTrackProps }) {
  return (
    <div
      style={{
        position: 'absolute',
        height: 10,
        zIndex: 1,
        marginTop: 25,
        backgroundColor: '#115E6E',
        borderRadius: 5,
        cursor: 'pointer',
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  )
}

function Tick({ tick, count }) {
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          marginTop: 42,
          marginLeft: -0.5,
          width: 1,
          height: 8,
          backgroundColor: 'silver',
          left: `${tick.percent}%`,
        }}
      />
      <div
        style={{
          position: 'absolute',
          marginTop: 50,
          fontSize: 10,
          textAlign: 'center',
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {tick.value}
      </div>
    </div>
  )
}

const SliderMinMax = (props) => {
  const { id, disabled, onChange, itemCount } = props

  const [currentValue, setCurrentValue] = useState();

  useEffect(() => {
    setCurrentValue(null)
  }, [itemCount])

  const sliderChange = (values) => {
    const sliderValues = {"name" : id, "values" : values}
    setCurrentValue(values[0])
    onChange(sliderValues)
  }

  const plusOne = () => {
    if(!currentValue){
      setCurrentValue(itemCount)
    } else if (currentValue < itemCount){
      const current = currentValue + 1
      setCurrentValue(current)
      sliderChange([current])
    }
  }

  const minusOne = () => {
    if(!currentValue){
      setCurrentValue(itemCount-1)
      sliderChange([itemCount-1])
    } else if(currentValue !== 1){
      const current = currentValue - 1
      setCurrentValue(current)
      sliderChange([current])
    }
  }

  const sliderStyle = { 
    position: 'relative',
    width: '100%',
    height: 70,
  }
  
  const railStyle = {
    position: 'absolute',
    width: '100%',
    height: 10,
    marginTop: 25,
    borderRadius: 5,
    backgroundColor: '#d3d3d3',
  }

  return (
    <label className={styles.slideContainer}>
      
      Select the number of schools to display. Schools are filtered by the number of children they serve<br />
      <div className={styles.sliderContainer}>
        <div className={styles.minus}>
          <span onClick={minusOne}>-</span>
        </div>
        <div className={styles.middle}>
        <Slider
        disabled={!disabled}
        rootStyle={sliderStyle}
        domain={[1, itemCount]}
        values={(currentValue) ? [currentValue] : [itemCount]}
        step={1}
        mode={2}
        onChange={sliderChange}
      >
         <Rail>
          {({ getRailProps }) => (
            <div style={railStyle} {...getRailProps()} />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map(handle => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  getHandleProps={getHandleProps}
                  disabled={!disabled}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={true} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                  disabled={!disabled}
                />
              ))}
            </div>
          )}
        </Tracks>
        <Ticks count={4}>
          {({ ticks }) => (
            <div className="slider-ticks">
              {ticks.map(tick => (
                <Tick key={tick.id} tick={tick} count={ticks.length} />
              ))}
            </div>
          )}
        </Ticks>
      </Slider>

        </div>
        <div className={styles.plus}><span onClick={plusOne}>+</span></div>
      </div>
    </label>
  )
}

export default SliderMinMax
